import React from 'react';
import { createRoot } from 'react-dom/client';
import { Security, LoginCallback, SecureRoute } from '@okta/okta-react';
import { Route, BrowserRouter as Router, Switch, useHistory } from 'react-router-dom';
import './index.css';
import WaitingListForm from './components/waiting-list-form.component';
import WaitingListSummary from './components/waiting-list-summary.component';
import SeasonTicketSummary from './components/season-ticket-summary.component';
import AppController from './appController';
import ClearLogin from './clearLogin';
import PartnerForm from './components/partner-form.component';
import Verify from './verify';
import OktaAuth, { toRelativeUrl } from '@okta/okta-auth-js';

const { REACT_APP_OKTA_ISSUER, REACT_APP_OKTA_CLIENT_ID, REACT_APP_HOLDER_SERVICE_HOST, REACT_APP_PROFILE_SERVICE_HOST } = process.env;

const App = () => {
    const holderServiceHost = REACT_APP_HOLDER_SERVICE_HOST;
    const identityServiceHost = REACT_APP_PROFILE_SERVICE_HOST;
    const history = useHistory()

    const oktaAuth = new OktaAuth({
      issuer: REACT_APP_OKTA_ISSUER,
      clientId: REACT_APP_OKTA_CLIENT_ID,
      redirectUri: `${window.location.origin}/login/callback`,
    })

    const restoreOriginalUri = async (_oktaAuth: OktaAuth, originalUri: string) => {
      history.replace(toRelativeUrl(originalUri || '/', window.location.origin));
    };

    return (
        <Security
          oktaAuth={oktaAuth}
          restoreOriginalUri={restoreOriginalUri}
        >
          <Switch>
            <Route path='/clearLogin'
              exact={true}
            >
              <ClearLogin />
            </Route>
            <SecureRoute path='/'
              exact={true}
            >
              <AppController
                holderHost={holderServiceHost!}
                identityHost={identityServiceHost!}
              />
            </SecureRoute>
            <SecureRoute path='/verify'>
              <Verify
                holderHost={holderServiceHost!}
              />
            </SecureRoute>
            <SecureRoute
              path='/waitlistForm'
            >
              <WaitingListForm
                holderHost={holderServiceHost!}
              />
            </SecureRoute>
            <SecureRoute
              path='/waitlistSummary'
            >
              <WaitingListSummary
                holderHost={holderServiceHost!}
              />
            </SecureRoute>
            <SecureRoute
              path='/seasonTicketSummary'
            >
              <SeasonTicketSummary
                holderHost={holderServiceHost!}
              />
            </SecureRoute>
            <SecureRoute
              path='/partnerForm'
            >
              <PartnerForm
                holderHost={holderServiceHost!}
              />
            </SecureRoute>
            <Route path={`/login/callback`}><LoginCallback /></Route>
          </Switch>
        </Security>
    )
}

const RouterWrapper = () => {
  return (
    <Router>
      <App />
    </Router>
  )
}

const rootElement: HTMLDivElement = document.getElementsByClassName('p-waiting-list')[0] as HTMLDivElement;
const root = createRoot(rootElement)
root.render(<RouterWrapper />)
